import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { Reveal } from "./Reveal";
import { IMAGES } from "../../lib/assets";

const CARDS = [
  { no: "I", title: "Residential", copy: "Luxury home closings handled with white-glove precision.", img: IMAGES.residential, route: "/residential" },
  { no: "II", title: "Commercial", copy: "Sophisticated title work for high-value commercial assets.", img: IMAGES.commercialLobby, route: "/commercial" },
  { no: "III", title: "Developers", copy: "Structured escrow for complex, multi-phase developments.", img: IMAGES.skyscraperDusk, route: "/developers" },
  { no: "IV", title: "Builders", copy: "Reliable partnerships engineered around your build schedule.", img: IMAGES.builders, route: "/builders" },
  { no: "V", title: "Investors", copy: "Discreet, efficient closings for portfolios of every scale.", img: IMAGES.marbleInterior, route: "/investors" },
  { no: "VI", title: "Luxury Agents", copy: "A closing experience worthy of your finest listings.", img: IMAGES.penthouse, route: null },
];

export const Services = () => {
  const navigate = useNavigate();
  return (
    <section className="relative bg-ink py-28 md:py-40" data-testid="services">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-20 gap-8">
          <div>
            <Reveal><div className="overline mb-6">Why Houston Title</div></Reveal>
            <Reveal delay={0.1}>
              <h2 className="font-serif font-light text-ivory text-5xl md:text-7xl leading-[0.98] tracking-tight max-w-2xl">
                Built for those who expect more.
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.2}>
            <p className="text-taupe font-light max-w-sm leading-relaxed md:text-right">
              A single standard of service — extended to every client we are privileged to represent.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {CARDS.map((c, i) => (
            <Reveal key={c.title} delay={(i % 3) * 0.1}>
              <motion.article
                whileHover={{ y: -8 }}
                transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
                onClick={() => c.route && navigate(c.route)}
                className={`group relative overflow-hidden bg-card border border-charcoal/60 h-[440px] ${c.route ? "cursor-pointer" : ""}`}
                data-testid={`service-card-${c.title.toLowerCase().replace(" ", "-")}`}
              >
                <div className="absolute inset-0 overflow-hidden">
                  <img
                    src={c.img}
                    alt={c.title}
                  className="h-full w-full object-cover opacity-60 grayscale-[30%] transition-all [transition-duration:1200ms] group-hover:opacity-80 group-hover:scale-105 group-hover:grayscale-0"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/50 to-transparent" />
                </div>
                <div className="relative z-10 h-full flex flex-col justify-between p-8">
                  <span className="font-serif text-gold text-2xl">{c.no}</span>
                  <div>
                    <h3 className="font-serif text-3xl text-ivory font-light mb-3">{c.title}</h3>
                    <p className="text-taupe text-sm font-light leading-relaxed max-w-xs opacity-0 translate-y-3 transition-all duration-500 group-hover:opacity-100 group-hover:translate-y-0">
                      {c.copy}
                    </p>
                  </div>
                </div>
                <span className="absolute bottom-0 left-0 h-px w-0 bg-gold transition-all duration-700 group-hover:w-full" />
              </motion.article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
